export enum CustomerType {
  BUSINESS = 'business',
  PERSONAL = 'personal',
}
